import React, { useState } from 'react';
import { useNavigate } from "react-router-dom";
import { Paper, Stack,IconButton } from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';

const SearchBar = ({setSelectedCategory}) => {
  const [searchTerm, setSearchTerm] = useState('');
  const navigate = useNavigate();

  const onhandleSubmit = (e) => {
    e.preventDefault();
    
    if (searchTerm) {
      setSelectedCategory("")
      navigate(`/search/${searchTerm}`);
      
      setSearchTerm('');
    }
  };

  return (

    
    <Stack
      direction="row"
      component='form'
      onSubmit={onhandleSubmit}
      sx={{
        borderRadius: 3,
        border: '1px solid #e3e3e3',
        pl: 2,
        boxShadow: 'none',
        mr: { sm: 5 },
        alignItems: "center",
        marginLeft: "25px",
        width: "50%",

      }}
    >
      <IconButton type='submit' sx={{ p: '10px', color: 'red' }} aria-label='search'>
        <SearchIcon />
      </IconButton>
      
      <input
        className='search-bar'
        placeholder='Search...'
        value={searchTerm}
        
        style={{ width :"100%",fontSize: "18px",color:"white",border: "none", outline: "none",backgroundColor: "transparent" }}
        //
        onChange={(e) => setSearchTerm(e.target.value)}
      />
      
    </Stack>
  );
};

export default SearchBar;